export class ConsultarMensajeDto {

  fecha?: string;
  estado?: number;
  codigoUsuario?: number;
  session?: number;
  currentPage?: number;
  limit?: number;

  constructor(init?: Partial<ConsultarMensajeDto>) {
    if (init) {
      Object.assign(this, init);
    }
  }
}
